export enum ProctorType {
  Proctor_1_And_Proctor_2 = 'PROCTOR_1_AND_PROCTOR_2',
  Proctor_3 = 'PROCTOR_3',
}
